import { render } from "./MMMemberResource.vue?vue&type=template&id=87b14168"
import script from "./MMMemberResource.vue?vue&type=script&lang=js"
export * from "./MMMemberResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__